import { render, staticRenderFns } from "./SuccessPayment.vue?vue&type=template&id=163ddd82"
import script from "./SuccessPayment.vue?vue&type=script&lang=js"
export * from "./SuccessPayment.vue?vue&type=script&lang=js"
import style0 from "./SuccessPayment.vue?vue&type=style&index=0&id=163ddd82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports